const route = () => '/login/callback';

export default route;
